<!-- eslint-disable-next-line -->
<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title>
          EMISSÃO DE PEDIDOS - LANÇAMENTO DE ITENS
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-tooltip top color="black" lazy v-if="company_promotion_id !== null">
          <template v-slot:activator="{ on }">
            <v-chip class="ma-2" color="red" label text-color="white" v-on="on">
              <v-icon left color="yellow" small> mdi-star </v-icon>
              Promoção:
              {{ promotion.description.substring(0, 25).toUpperCase() }}
            </v-chip>
          </template>
          <span>{{ promotion.description }}</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-toolbar-title v-if="cart.id">
          Pedido: {{ company.code }} - {{ cart.code }}
        </v-toolbar-title>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <alert
            :visible="!!error"
            dark
            type="error"
            :message="error"
            :clickClose="() => (error = '')"
          />
          <v-row>
            <v-col cols="6" xs="6" md="5" lg="4">
              <v-row>
                <v-col cols="12" xs="12" md="12" class="py-2">
                  <v-autocomplete
                    :items="companies"
                    :item-text="(item) => `${item.code} - ${item.name}`"
                    item-value="id"
                    v-model="companySelected"
                    label="Franqueado"
                    @change="handleSelectedCompany()"
                    :disabled="verifyDisabledCompany()"
                    hide-details
                    autofocus
                    clearable
                    dense
                    outlined
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  xs="12"
                  :md="company_promotion_id !== null ? 6 : 8"
                  class="pr-0 py-2"
                >
                  <v-text-field
                    v-model="reference"
                    class="text-field-uppercase"
                    label="Referência"
                    dense
                    autofocus
                    outlined
                    :error-messages="reference_error"
                    :disabled="disabledOnEdit()"
                    @keydown.enter.prevent="searchProduct()"
                    @focus="handleReference()"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  xs="12"
                  :md="company_promotion_id !== null ? 6 : 4"
                  class="py-2"
                >
                  <v-tooltip top v-if="company_promotion_id === null">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        color="primary"
                        class="mr-2 mt-2"
                        v-bind="attrs"
                        v-on="on"
                        @click="handleClickSearchAdvanced()"
                        :disabled="disabledOnEdit()"
                      >
                        mdi-magnify
                      </v-icon>
                    </template>
                    <span>Busca Avançada</span>
                  </v-tooltip>
                  <v-btn
                    v-if="company_promotion_id === null"
                    color="green darken-3"
                    class="white--text mt-2"
                    small
                    @click="searchProduct()"
                    :disabled="disabledOnEdit()"
                  >
                    Buscar
                  </v-btn>
                  <v-btn
                    v-if="company_promotion_id !== null"
                    color="blue darken-3"
                    class="white--text mt-2 ml-2"
                    small
                    @click="searchProductPromotion()"
                    :disabled="disabledOnEdit()"
                  >
                    Produtos em Promoção
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" md="12" class="py-2">
                  <label class="text-h6">
                    Produto
                    {{ isEditing() ? "- Edição" : "" }}
                  </label>
                  <v-divider class="mb-0"></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" md="12" class="py-2">
                  <label class="font-weight-bold">Fornecedor: </label>
                  <span>{{ fullProvider }}</span>
                  <!-- <v-text-field
                    v-model="fullProvider"
                    class="text-field-uppercase border-color-field"
                    label="Fornecedor"
                    dense
                    outlined
                    disabled
                    hide-details
                  ></v-text-field> -->
                </v-col>
                <v-col cols="12" xs="12" md="12" class="py-2">
                  <v-text-field
                    class="text-field-uppercase border-color-field"
                    label="Referência:"
                    dense
                    readonly
                    outlined
                    v-model="fullReference"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="12" class="py-2">
                  <v-text-field
                    class="text-field-uppercase border-color-field"
                    label="Nome:"
                    v-model="product_order.name"
                    dense
                    readonly
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="12" class="py-2">
                  <v-text-field
                    class="text-field-uppercase border-color-field"
                    label="Categoria:"
                    v-model="product_order.category_name"
                    dense
                    readonly
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="12" class="py-2">
                  <v-text-field
                    class="text-field-uppercase border-color-field"
                    label="Subcategoria:"
                    v-model="product_order.subcategory_name"
                    dense
                    readonly
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="12" class="py-2">
                  <v-text-field
                    class="text-field-uppercase border-color-field"
                    label="Preço:"
                    v-model="getPrice"
                    dense
                    readonly
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="12" class="py-2">
                  <v-select
                    :items="materials"
                    :item-text="(item) => `${item.name}`"
                    item-value="id"
                    v-model="material"
                    @change="handleChangeMaterial()"
                    label="Material:"
                    :error="material_error"
                    hide-details
                    clearable
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="12" xs="12" md="12" class="py-2">
                  <v-select
                    :items="colors"
                    :item-text="(item) => `${item.name}`"
                    item-value="id"
                    v-model="color_product"
                    @change="handleChangeColor(true)"
                    label="Cor:"
                    hide-details
                    :error="color_error"
                    clearable
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6" xs="6" md="7" lg="8" class="py-2">
              <v-icon left color="blue darken-3">mdi-cart-variant</v-icon>
              <label class="text-h6">Carrinho</label>
              <v-divider class="mb-5"></v-divider>
              <alert
                :visible="!!message_add_to_cart"
                dark
                type="success"
                :message="message_add_to_cart"
                :clickClose="() => (message_add_to_cart = '')"
              />
              <v-row>
                <v-col
                  v-if="
                    conditions.minimum_order.value !== '' &&
                    conditions.minimum_order.value != 0
                  "
                >
                  <strong
                    :class="hitMinimumOrder() ? 'green--text' : 'red--text'"
                  >
                    Pedido Mínimo
                    {{ formatMinimumOrderValue() }}
                  </strong>
                  <v-icon
                    right
                    :color="
                      hitMinimumOrder() ? 'green darken-1' : 'red darken-1'
                    "
                    >{{
                      hitMinimumOrder()
                        ? "mdi-checkbox-marked-circle-outline"
                        : "mdi-close-circle-outline"
                    }}</v-icon
                  >
                </v-col>
                <v-col v-if="conditions.shipping.value !== ''">
                  <strong
                    :class="
                      hitShippingCondition() ? 'green--text' : 'red--text'
                    "
                    >Frete CIF {{ formatShippingValue() }}</strong
                  >
                  <v-icon
                    right
                    :color="
                      hitShippingCondition() ? 'green darken-1' : 'red darken-1'
                    "
                    >{{
                      hitShippingCondition()
                        ? "mdi-checkbox-marked-circle-outline"
                        : "mdi-close-circle-outline"
                    }}</v-icon
                  >
                </v-col>
                <v-col v-else>
                  <strong class="grey--text text--darken-2"
                    >Frete CIF Não Disponível</strong
                  >
                  <v-icon right color="orange darken-2">mdi-alert</v-icon>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-2">
                  <v-simple-table dense fixed-header height="270">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-right fs-12 text-no-wrap">Item</th>
                          <th
                            class="text-left fs-12 text-no-wrap"
                            width="120px"
                          >
                            Foto
                          </th>
                          <th class="text-left fs-12 text-no-wrap">
                            Referência
                          </th>
                          <th class="text-left fs-12 text-no-wrap">Material</th>
                          <th class="text-left fs-12 text-no-wrap">Cor</th>
                          <th class="text-right fs-12 text-no-wrap">Qtde.</th>
                          <th class="text-right fs-12 text-no-wrap">
                            Valor Unit.
                          </th>
                          <th class="text-right fs-12 text-no-wrap">
                            Valor Total
                          </th>
                          <th
                            class="text-right fs-12 text-no-wrap"
                            width="100px"
                          >
                            Ações
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in cart.items"
                          :key="`${item.reference}${item.color.id}${item.material.id}`"
                          :class="item.editing ? 'cart-editing' : ''"
                        >
                          <td class="text-right">{{ index + 1 }}</td>
                          <td>
                            <v-img
                              :src="getUrlPhoto(item.color.photo)"
                              alt=""
                              max-width="120"
                              :aspect-ratio="16 / 9"
                              class="my-2 image-clickable"
                              @click="
                                onClickImage(getUrlPhoto(item.color.photo))
                              "
                            ></v-img>
                          </td>
                          <td>{{ item.provider_code }}{{ item.reference }}</td>
                          <td>
                            {{ item.material.name }}
                          </td>
                          <td>
                            {{ item.color.name }}
                          </td>
                          <td class="text-right">
                            {{ getQuantitySum(item) }}
                          </td>
                          <td class="text-right">
                            {{ getPriceByType(item) | currencyEuaToBr }}
                          </td>
                          <td class="text-right">
                            {{ getTotalPrice(item) | currencyEuaToBr }}
                          </td>
                          <td class="text-right">
                            <v-tooltip top color="blue ">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="blue darken-3"
                                  class="mr-2"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="handleEditProduct(item)"
                                >
                                  mdi-pencil
                                </v-icon>
                              </template>
                              <span>Editar Produto</span>
                            </v-tooltip>
                            <v-tooltip top color="red">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="red darken-3"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="handleDeleteProduct(item)"
                                >
                                  mdi-delete
                                </v-icon>
                              </template>
                              <span>Remover Produto</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <th class="text-right">{{ cart.items.length }}</th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th class="text-right">
                            {{ getSumAmountOrder() }}
                          </th>
                          <th class="text-right"></th>
                          <th class="text-right">
                            {{ getSumValueOrder() | currencyEuaToBr }}
                          </th>
                          <th></th>
                        </tr>
                      </tfoot>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
              <v-row>
                <v-col><v-divider class="mb-0"></v-divider></v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" class="py-2 d-flex justify-center">
                  <v-img
                    :src="photo"
                    alt=""
                    max-width="420"
                    @click="onClickImage(photo)"
                    class="image-clickable"
                    contain
                    :aspect-ratio="16 / 9"
                  ></v-img>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" class="mb-0 py-2 pb-0">
              <label for="">Informe as Quantidades:</label>
            </v-col>
            <v-col
              cols="12"
              xs="12"
              class="py-2 pb-0"
              v-if="grid.type !== 'fechada'"
            >
              <div
                v-for="(size, index) in sizes"
                :key="size.size"
                style="width: 50px; float: left; margin-right: 5px"
                class="py-0"
              >
                <label style="padding-left: 15px">{{ size.size }}</label>
                <v-text-field
                  v-model="size.quantity"
                  outlined
                  dense
                  hide-details
                  @focus="onFocusSize(size, index)"
                  @blur="onBlurSize(size, index)"
                ></v-text-field>
              </div>
            </v-col>
            <v-col
              cols="12"
              xs="12"
              class="py-2 pb-0"
              v-if="grid.type === 'fechada'"
            >
              <div
                v-for="size in sizes"
                :key="size.size"
                style="width: 80px; float: left; margin-right: 5px"
                class="py-0"
              >
                <label style="padding-left: 15px">{{ size.size }}</label>
                <v-select
                  :items="getOptionsGrid()"
                  v-model="size.quantity"
                  hide-details
                  dense
                  outlined
                ></v-select>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" xs="6" md="5" lg="4" class="py-2">
              <alert
                :visible="!!error_validate"
                dark
                type="error"
                :message="error_validate"
                :clickClose="() => (error_validate = '')"
              />
              <v-btn
                :color="isEditing() ? 'amber accent-4' : 'blue darken-3'"
                :class="isEditing() ? 'mt-0' : 'mt-0 white--text'"
                @click="validate"
              >
                <v-icon left>mdi-cart-plus</v-icon>
                {{
                  isEditing()
                    ? "Salvar Edição Produto"
                    : "Adicionar ao Carrinho"
                }}
              </v-btn>
            </v-col>
            <v-col cols="6" xs="6" md="7" lg="8" class="py-2">
              <v-btn
                color="blue darken-3"
                dark
                class="mt-3 float-right"
                @click="goToNextPage()"
              >
                Avançar
                <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
              <v-btn
                color="red darken-3"
                dark
                outlined
                class="mt-3 float-right mr-4"
                @click="cancelOrder()"
              >
                <v-icon left>mdi-close</v-icon>
                Cancelar Pedido
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <ImageZoom
      :visible="dialogZoomPhoto"
      :closeDialog="closeDialogZoomPhoto"
      :photo="photoDialogZoom"
    />
    <v-dialog
      v-model="dialogSearchAvanced"
      fullscreen
      hide-overlay
      ref="dialogSearch"
    >
      <v-card>
        <v-toolbar dark dense color="primary">
          <!-- <v-btn icon dark @click="dialogSearchAvanced = false">
            <v-icon>mdi-close</v-icon>
          </v-btn> -->
          <v-toolbar-title>Busca Avançada</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <!-- <v-btn
              text
              class="white--text"
              @click="handleConfirmAdvancedSearch()"
            >
              Confirmar
            </v-btn> -->
          </v-toolbar-items>
        </v-toolbar>
        <v-card-title></v-card-title>
        <v-divider></v-divider>
        <v-card-text style="padding-top: 10px">
          <v-expansion-panels v-model="dialogSearchAdvancedPanel">
            <v-expansion-panel :key="1">
              <v-expansion-panel-header class="font-weight-black">
                Filtros
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-progress-linear
                  :active="loadingDialogSearch"
                  :indeterminate="loadingDialogSearch"
                  absolute
                  bottom
                  color="deep-purple accent-4"
                ></v-progress-linear>
                <v-row>
                  <v-col class="d-flex" cols="12" sm="6" md="4">
                    <v-autocomplete
                      :items="providers"
                      v-model="search.provider"
                      label="Fornecedor"
                      :item-text="(item) => `${item.code} - ${item.name}`"
                      item-value="id"
                      hide-details
                      clearable
                      dense
                      outlined
                      :loading="loadingProviders"
                      :disabled="cart.provider_id !== ''"
                      @input="handleChangeProviderAdvancedSearch()"
                    ></v-autocomplete>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="6" md="4">
                    <v-select
                      :items="collections"
                      v-model="search.collection"
                      label="Coleção"
                      :item-text="(item) => `${item.name}`"
                      item-value="id"
                      hide-details
                      clearable
                      dense
                      outlined
                      :loading="loadingCollections"
                    ></v-select>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="6" md="4">
                    <v-select
                      :items="categories"
                      v-model="search.category"
                      label="Categoria"
                      :item-text="(item) => `${item.name}`"
                      item-value="id"
                      hide-details
                      clearable
                      dense
                      outlined
                      :loading="loadingCategories"
                    ></v-select>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="6" md="4">
                    <v-select
                      :items="subcategories"
                      v-model="search.subcategory"
                      label="Subcategoria"
                      :item-text="(item) => `${item.name}`"
                      item-value="id"
                      hide-details
                      clearable
                      dense
                      outlined
                      :loading="loadingSubcategories"
                    ></v-select>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="6" md="4">
                    <v-autocomplete
                      v-model="search.material"
                      :items="materials_search"
                      label="Material"
                      :item-text="(item) => `${item.code} - ${item.name}`"
                      item-value="id"
                      hide-details
                      clearable
                      dense
                      outlined
                      :loading="loadingMaterials"
                    ></v-autocomplete>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="6" md="4">
                    <v-autocomplete
                      v-model="search.color"
                      :items="colors_search"
                      label="Cor"
                      :item-text="(item) => `${item.code} - ${item.name}`"
                      item-value="id"
                      hide-details
                      clearable
                      dense
                      outlined
                      :loading="loadingColors"
                    ></v-autocomplete>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="6" md="4">
                    <v-select
                      v-model="search.technologies"
                      :items="technologies"
                      :item-text="(item) => `${item.name}`"
                      item-value="id"
                      chips
                      label="Tecnologias"
                      hide-details
                      clearable
                      multiple
                      dense
                      outlined
                      :loading="loadingTechnologies"
                    >
                      <template v-slot:selection="{ item, index }">
                        <span v-if="index === 0">{{ item.name }} &nbsp;</span>
                        <span v-if="index === 1" class="text-caption">
                          [ +{{ search.technologies.length - 1 }} outro(s) ]
                        </span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="search.reference"
                      class="text-field-uppercase"
                      label="Referência"
                      hide-details
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="6" md="4">
                    <v-btn
                      color="green darken-3 mt-2"
                      class="white--text"
                      small
                      @click="searchProductAdvanced()"
                    >
                      Buscar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel :key="2">
              <v-expansion-panel-header class="font-weight-black">
                Produtos
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col class="pb-0">
                    <label>
                      {{ products_search.length }} Produtos Encontrados
                    </label>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-data-table
                      :headers="headersAdvancedSearch"
                      :items="products_search"
                      :loading="loadingDialogSearch"
                      :items-per-page="5"
                      item-key="key"
                      class="elevation-1"
                      sort-by="referenceFull"
                      dense
                    >
                      <template v-slot:[`item.radio`]="{ item }">
                        <v-radio-group v-model="radioGroupProduct">
                          <v-radio
                            :value="`${item.id}${item.material_id}${item.color_id}`"
                          ></v-radio>
                        </v-radio-group>
                      </template>
                      <template v-slot:[`item.photo`]="{ item }">
                        <v-img
                          :src="getUrlPhoto(item.photo)"
                          alt=""
                          max-width="120"
                          :aspect-ratio="16 / 9"
                          class="my-2 image-clickable"
                          @click="onClickImage(getUrlPhoto(item.photo))"
                        ></v-img>
                      </template>
                      <template v-slot:[`item.reference`]="{ item }">
                        {{ item.provider_code }}{{ item.reference }}
                      </template>
                      <template v-slot:[`item.provider`]="{ item }">
                        {{ item.provider_code }} - {{ item.provider_name }}
                      </template>
                      <template v-slot:[`item.price`]="{ item }">
                        {{ getPriceByType(item) | currencyEuaToBr }}
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="dialogSearchAvanced = false"
          >
            Fechar
          </v-btn>
          <v-btn
            color="blue darken-1"
            class="white--text"
            @click="handleConfirmAdvancedSearch()"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCancel" persistent max-width="480px">
      <v-card>
        <v-card-title>Cancelar Pedido</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4">
          Deseja Realmente cancelar a emissão desse pedido?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="dialogCancel = false">
            Fechar
          </v-btn>
          <v-btn
            color="red darken-3"
            class="white--text"
            outlined
            @click="handleConfirmCancelOrder()"
          >
            <v-icon left>mdi-close</v-icon>
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDraftOrders" persistent max-width="1100px">
      <v-card>
        <v-card-title>
          <span>Pedidos em Manutenção (Pendentes)</span>
          <v-spacer></v-spacer>
          <v-icon @click="dialogDraftOrders = false"> mdi-close </v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4">
          <v-row>
            <v-col>
              <v-simple-table dense fixed-header height="270">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left fs-12 text-no-wrap">#</th>
                      <th class="text-left fs-12 text-no-wrap">Pedido</th>
                      <th class="text-left fs-12 text-no-wrap">Franqueado</th>
                      <th class="text-left fs-12 text-no-wrap">Fornecedor</th>
                      <th class="text-right fs-12 text-no-wrap">Produtos</th>
                      <th class="text-right fs-12 text-no-wrap">Quantidade</th>
                      <th class="text-right fs-12 text-no-wrap">Valor</th>
                      <th class="text-left fs-12 text-no-wrap">Data</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in drafts" :key="`${item.id}`">
                      <td>
                        <v-radio-group v-model="radioGroupDraft">
                          <v-radio :value="item.id"></v-radio>
                        </v-radio-group>
                      </td>
                      <td>{{ item.franchise_code }} - {{ item.code }}</td>
                      <td>
                        {{ item.franchise_code }} - {{ item.franchise_name }}
                      </td>
                      <td>
                        {{ item.provider_code }} - {{ item.provider_name }}
                      </td>
                      <td class="text-right">{{ item.products.length }}</td>
                      <td class="text-right">{{ item.quantity_items }}</td>
                      <td class="text-right">
                        {{ item.value | currencyEuaToBr }}
                      </td>
                      <td>{{ item.created_at | dateFormatBr }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1 white--text"
            @click="handleClickGoToPromotion()"
          >
            Promoções
          </v-btn>
          <v-btn
            color="green darken-1 white--text"
            @click="dialogDraftOrders = false"
          >
            Iniciar Novo Pedido
          </v-btn>
          <v-btn
            color="blue darken-3"
            class="white--text"
            @click="handleConfirmDraft()"
          >
            <v-icon left>mdi-check</v-icon>
            Selecionar Pedido
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeleteProduct" persistent max-width="480px">
      <v-card>
        <v-card-title>Remover Produto</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4">
          Deseja Realmente remover esse produto neste pedido?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="handleCancelDeleteProduct()"
          >
            Fechar
          </v-btn>
          <v-btn
            color="red darken-3"
            class="white--text"
            outlined
            @click="handleConfirmDeleteProduct()"
          >
            <v-icon left>mdi-delete</v-icon>
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { URL, URL_IMAGE } from "@/api/config";

import * as ColorAPI from "@/api/requests/ColorRequest";
import * as CompanyAPI from "@/api/requests/CompanyRequest";
import * as CompanyPromotionAPI from "@/api/requests/CompanyPromotionRequest";
import * as ShippingAPI from "@/api/requests/ShippingRequest";
import * as HTTP from "@/api/requests/base";

import { UF_REGIONS } from "@/api/constants";
import Alert from "@/components/Alert";
import ImageZoom from "@/components/ImageZoom";

export default {
  components: {
    Alert,
    ImageZoom,
  },
  data: () => ({
    loading: false,
    error: "",
    reference: "",
    products_search: [],
    product_edit: {},
    index_product_edit: -1,
    company_promotion_id: null,
    product_order: {
      id: "",
      reference: "",
      name: "",
      unit_id: "",
      unit_name: "",
      grid_id: "",
      category_id: "",
      category_name: "",
      subcategory_id: "",
      subcategory_name: "",
      price_cif: "",
      price_mult: "",
      provider_id: "",
      provider_name: "",
      provider_code: "",
      editing: false,
    },
    photo: "",
    dialogZoomPhoto: false,
    photoDialogZoom: "",
    product_new: {
      id: "",
      reference: "",
      name: "",
      unit_id: "",
      unit_name: "",
      grid_id: "",
      category_id: "",
      category_name: "",
      subcategory_id: "",
      subcategory_name: "",
      price_cif: "",
      price_mult: "",
      provider_id: "",
      provider_name: "",
      provider_code: "",
      editing: false,
    },
    reference_error: "",
    color: {
      id: "",
      name: "",
      status: 1,
    },
    color_new: {
      id: "",
      name: "",
      status: 1,
    },
    price: "",
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
    companies: [],
    companySelected: "",
    company: {
      id: "",
      code: "",
      name: "",
      type: "",
    },
    provider: {},
    materials: [],
    attributes: [],
    material: "",
    colors: [],
    color_product: "",
    sizes: [],
    cart: {
      id: "",
      provider_id: "",
      franchise_id: "",
      company_promotion_id: null,
      code: "",
      status: "draft",
      items: [],
    },
    material_error: false,
    color_error: false,
    error_validate: "",
    message_add_to_cart: "",
    search: {
      provider: "",
      category: "",
      subcategory: "",
      technologies: [],
      reference: "",
      collection: "",
      material: "",
      color: "",
    },
    providers: [],
    categories: [],
    subcategories: [],
    technologies: [],
    collections: [],
    materials_search: [],
    colors_search: [],
    dialogSearchAdvancedPanel: 0,
    dialogSearchAvanced: false,
    radioGroupProduct: 0,
    dialogCancel: false,
    dialogDeleteProduct: false,
    item_delete: {},
    loadingDialogSearch: false,
    dialogDraftOrders: false,
    drafts: [],
    radioGroupDraft: 0,
    headersAdvancedSearch: [
      { text: "#", value: "radio" },
      { text: "Foto", value: "photo" },
      { text: "Referência", value: "referenceFull" },
      { text: "Nome", value: "name" },
      { text: "Material", value: "material_name" },
      { text: "Cor", value: "color_name" },
      { text: "Fornecedor", value: "provider" },
      { text: "Categoria", value: "category_name" },
      { text: "Subcategoria", value: "subcategory_name" },
      { text: "Valor", value: "price" },
    ],
    loadingProviders: false,
    loadingCollections: false,
    loadingCategories: false,
    loadingSubcategories: false,
    loadingMaterials: false,
    loadingColors: false,
    loadingTechnologies: false,
    searchWithProvider: false,
    pageNext: "checkout",
    promotion: {
      id: null,
      description: "",
    },
    grid: {},
    conditions: {
      shipping: {
        value: "",
        type: "",
      },
      minimum_order: {
        value: "",
        type: "",
      },
    },
    companySessionSelected: {
      id: "",
    },
  }),
  computed: {
    fullReference() {
      if (this.product_order.reference == "") {
        return "";
      }
      return `${this.product_order.provider_code} ${this.product_order.reference}`;
    },
    fullProvider() {
      if (this.providerIsSelected()) {
        return `${this.provider.code} - ${this.provider.name}`;
      } else {
        return "";
      }
    },
    getPrice() {
      if (this.product_order.id == "") {
        return "";
      }
      let price =
        this.company.type == "fra"
          ? this.product_order.price_cif
          : this.product_order.price_mult;
      return this.currencyEuaToBr(price);
    },
  },
  watch: {
    "provider.id"(value) {
      this.getShipping(value);
      // this.provider(value);
      console.log(value);
      console.log("DIEGO");
    },
  },
  filters: {
    currencyEuaToBr: function (value) {
      if (!value) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    dateFormatBr: function (value) {
      let [date, hours] = value.split(" ");
      date = date.split("-").reverse().join("/");
      return `${date} ${hours}`;
    },
  },
  created() {
    let session = localStorage.getItem(HTTP.COMMON_LOCAL_STORAGE_KEY);
    if (session) {
      session = JSON.parse(session);
      if (
        session.company_selected !== "" &&
        session.company_selected !== undefined
      ) {
        this.companySessionSelected = session.company_selected;
        this.companySelected = this.companySessionSelected.id;
        this.company = this.companySessionSelected;
      }
      this.initialize();
    } else {
      this.initialize();
    }
  },
  methods: {
    async initialize() {
      console.log(this.companySessionSelected);
      // this.getPromotion(1);
      if (this.$route.params.page) {
        this.pageNext = this.$route.params.page;
      }
      if (this.$route.params.id) {
        this.getDraft(this.$route.params.id);
      } else if (this.$route.params.company_promotion_id) {
        this.getPromotion(this.$route.params.company_promotion_id);
      } else {
        if (this.companySessionSelected.id !== "") {
          this.verifyDraftOrders();
        }
      }
      this.getCompanies("fra,mul");
    },
    async getCompanies(type) {
      // this.loading = true;
      try {
        let data = await CompanyAPI.getAll(`?type=${type}`);
        this.companies = data.sort((a, b) => (a.code > b.code ? 1 : -1));
      } catch (error) {
        this.companies = [];
        console.log(error);
      } finally {
        // this.loading = false;
      }
    },
    async getColor(id) {
      this.error = "";
      // this.showLoading();
      this.loading = true;
      try {
        this.color = await ColorAPI.getById(id);
      } catch (error) {
        this.color = {};
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    validate() {
      if (this.material == "" || this.material == null) {
        this.error_validate = "Selecione um Material para poder continuar";
        this.material_error = true;
        return false;
      }
      if (this.color_product == "" || this.material == null) {
        this.error_validate = "Selecione uma Cor para poder continuar";
        this.color_error = true;
        return false;
      }

      if (this.getQuantitySum({ sizes: this.sizes }) === 0) {
        this.error_validate = "Informe uma quantidade na grade";
        return false;
      }

      let data = { ...this.product_order };
      data.material = this.materials.find((item) => item.id === this.material);
      data.color = this.colors.find((item) => item.id === this.color_product);
      data.color_id = data.color.color;
      data.material_id = data.material.id;
      data.sizes = this.sizes;

      if (typeof data.editing === "undefined") {
        data.editing = false;
      }
      const edit = data.editing;

      data.price = this.getPriceByType(data);

      if (this.verifyProductsCart(data) && !edit) {
        this.error_validate =
          "Este Produto com esse Material e Cor já está no Carrinho";
        return false;
      }

      this.saveOrderDraft(data, edit);
      console.log(data);
    },
    addToCart(product, edit) {
      console.log("addToCart");
      if (edit) {
        product.editing = false;
        this.cart.items.splice(this.index_product_edit, 1, product);
      }

      this.product_order = { ...this.product_new };
      this.product_edit = {};
      this.products_search = [];
      this.sizes = [];
      this.colors = [];
      this.materials = [];
      this.color = { ...this.color_new };
      this.attributes = [];
      this.photo = "";
      this.reference = "";
      this.reference_error = "";
      this.$vuetify.goTo(0, {
        duration: 300,
        offset: 0,
        easing: "easeInOutCubic",
      });
      this.message_add_to_cart = edit
        ? "Produto Atualizado"
        : "Produto Adicionado ao Carrinho";

      // this.saveOrderDraft();
    },
    async post() {},
    async update() {},
    getLabelStatus(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
    getSumAmountOrder() {
      return this.cart.items
        .map((item) => this.getQuantitySum(item))
        .reduce((prev, curr) => prev + curr, 0);
    },
    getSumValueOrder() {
      return this.cart.items
        .map((item) => {
          let price =
            this.company.type == "fra" ? item.price_cif : item.price_mult;
          let quantity = this.getQuantitySum(item);
          return price * quantity;
        })
        .reduce((prev, curr) => prev + curr, 0)
        .toFixed(2);
    },
    async searchProduct() {
      this.message_add_to_cart = "";
      if (this.company.id == "") {
        this.error = "Selecione um Franqueado para poder Continuar";
        return false;
      }
      if (this.reference == "") {
        this.reference_error = "Preencha uma Referência para poder Buscar";
        return false;
      }

      this.loading = true;
      this.products_search = [];
      this.reference_error = "";
      this.product_order = { ...this.product_new };
      const provider_id = this.providerIsSelected() ? this.provider.id : "";
      const body = {
        reference: this.reference,
        provider: provider_id,
        company_promotion_id: this.company_promotion_id,
        franchise: this.company.id,
      };
      let myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        let response = await fetch(`${URL}product/search-order`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(body),
        });
        let data = await response.json();

        this.products_search = data.products.map((item) => ({
          ...item,
          referenceFull: `${item.provider_code}${item.reference}`,
        }));

        if (data.products.length == 0) {
          if (this.providerIsSelected()) {
            this.reference_error =
              this.company_promotion_id !== null
                ? "Referência não encontrada nesta Promoção"
                : "Referência não encontrada neste Fornecedor";
          } else {
            this.reference_error = "Referência não encontrada";
          }
        } else if (data.products.length > 1) {
          if (data.items == 1) {
            this.product_order = data.products[0];
            this.provider = {
              id: this.product_order.provider_id,
              name: this.product_order.provider_name,
              code: this.product_order.provider_code,
            };
            // this.price = this.getPrice();
            this.getMaterials(this.product_order.id);
            this.getGrids(this.product_order.grid_id);
          } else {
            this.dialogSearchAvanced = true;
            this.dialogSearchAdvancedPanel = 1;
            this.radioGroupProduct = 0;
          }
        } else {
          this.product_order = data.products[0];
          this.provider = {
            id: this.product_order.provider_id,
            name: this.product_order.provider_name,
            code: this.product_order.provider_code,
          };
          // this.price = this.getPrice();
          this.getMaterials(this.product_order.id);
          this.getGrids(this.product_order.grid_id);
        }

        console.log(data);
      } catch (error) {
        this.products_search = [];
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async searchProductPromotion() {
      this.message_add_to_cart = "";
      if (this.company.id == "") {
        this.error = "Selecione um Franqueado para poder Continuar";
        return false;
      }
      this.handleClickSearchAdvanced();
      this.dialogSearchAdvancedPanel = 1;

      this.loading = true;
      this.loadingDialogSearch = true;
      this.products_search = [];
      this.reference_error = "";
      this.product_order = { ...this.product_new };
      const body = {
        reference: this.provider.code,
        provider: this.provider.id,
        company_promotion_id: this.company_promotion_id,
        franchise: this.company.id,
      };
      let myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        let response = await fetch(`${URL}product/search-order`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(body),
        });
        let data = await response.json();

        this.products_search = data.products.map((item) => ({
          ...item,
          referenceFull: `${item.provider_code}${item.reference}`,
        }));
        this.radioGroupProduct = 0;

        console.log(data);
      } catch (error) {
        this.products_search = [];
        console.log(error);
      } finally {
        this.loading = false;
        this.loadingDialogSearch = false;
      }
    },
    async getMaterials(id) {
      this.loading = true;
      this.attributes = [];
      this.materials = [];
      this.material = "";
      this.color_product = "";
      this.photo = "";
      try {
        let response = await fetch(`${URL}product/product-attr/${id}`);
        let data = await response.json();
        this.attributes = data;

        if (this.attributes.length > 0) {
          this.photo = this.getUrlPhoto(this.attributes[0].photo);
        }

        this.materials = data.map((item) => ({
          id: item.material_id,
          name: item.material_name,
        }));
        this.materials = [
          ...new Map(this.materials.map((item) => [item["id"], item])).values(),
        ];
        console.log(this.materials);
      } catch (error) {
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    async getGrids(id) {
      this.loading = true;
      this.sizes = [];
      try {
        let response = await fetch(`${URL}product/product-sizes/${id}`);
        let data = await response.json();
        this.sizes = data.sizes.map((item) => ({ size: item, quantity: 0 }));
        this.grid = data.grid;
        console.log(this.sizes);
      } catch (error) {
        this.sizes = [];
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    getUrlPhoto(photo) {
      if (photo !== "") {
        return `${URL_IMAGE}${photo}`;
      } else {
        return "";
      }
    },
    handleChangeMaterial() {
      this.material_error = false;
      this.colors = this.attributes.filter(
        (item) => item.material_id == this.material
      );
      this.colors = this.colors.map((item) => ({
        color: item.color_id,
        id: item.id,
        name: item.color_name,
        photo: item.photo,
      }));
    },
    handleChangeColor(validProductColor = false) {
      this.color_error = false;
      let data = this.attributes.find((item) => item.id == this.color_product);
      this.photo = this.getUrlPhoto(data.photo);

      if (validProductColor) {
        let dataValid = { ...this.product_order };
        dataValid.material = this.materials.find(
          (item) => item.id === this.material
        );
        dataValid.color = this.colors.find(
          (item) => item.id === this.color_product
        );
        dataValid.sizes = this.sizes;

        const edit = dataValid.editing;

        dataValid.editing = false;
        if (this.verifyProductsCart(dataValid) && !edit) {
          this.error_validate =
            "Este Produto com esse Material e Cor já está no Carrinho";
          return false;
        }
      }
    },
    currencyEuaToBr(value) {
      if (!value) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    handleSelectedCompany() {
      if (this.companySelected == "") {
        this.company = {
          id: "",
          code: "",
          name: "",
          type: "",
          delivery_state: "",
        };
        return;
      }
      const companyObject = this.companies.find(
        (item) => item.id === this.companySelected
      );
      console.log(companyObject);
      this.company = { ...companyObject };
    },
    getTotalValue(item) {
      return (parseFloat(item.value) * parseInt(item.quantity)).toFixed(2);
    },
    onClickImage(photo) {
      if (photo == "") return;
      this.photoDialogZoom = photo;
      this.dialogZoomPhoto = true;
    },
    closeDialogZoomPhoto() {
      this.dialogZoomPhoto = false;
      this.photoDialogZoom = "";
    },
    getQuantitySum(item) {
      return item.sizes
        .map((prod) =>
          isNaN(parseInt(prod.quantity)) ? 0 : parseInt(prod.quantity)
        )
        .reduce((prev, curr) => prev + curr, 0);
    },
    getPriceByType(item) {
      return this.company.type == "fra" ? item.price_cif : item.price_mult;
    },
    getTotalPrice(item) {
      let price = this.company.type == "fra" ? item.price_cif : item.price_mult;
      let quantity = this.getQuantitySum(item);
      return (price * quantity).toFixed(2);
    },
    goToNextPage() {
      if (this.cart.items.length === 0) {
        alert("O carrinho está vazio, adicione produtos para poder continuar");
        return false;
      }
      if (this.isEditing()) {
        alert("Existe um produto em Edição! Salve o produto para continuar.");
        return false;
      }
      if (this.pageNext === "admin") {
        this.$router.push({
          name: "OrdersEditAdmin",
          params: { order: this.cart.id, pageBack: this.pageNext },
        });
      } else {
        this.$router.push({ path: `/pedidos/checkout/${this.cart.id}` });
      }
    },
    async handleEditProduct(item) {
      this.cart.items = [
        ...this.cart.items.map((prod) => ({ ...prod, editing: false })),
      ];
      await this.getMaterials(item.id);
      await this.getGrids(item.grid_id);
      this.product_edit = {
        id: item.id,
        reference: item.reference,
        name: item.name,
        unit_id: item.unit_id,
        unit_name: item.unit_name,
        grid_id: item.grid_id,
        category_id: item.category_id,
        category_name: item.category_name,
        subcategory_id: item.subcategory_id,
        subcategory_name: item.subcategory_name,
        price_cif: item.price_cif,
        price_mult: item.price_mult,
        provider_id: item.provider_id,
        provider_name: item.provider_name,
        provider_code: item.provider_code,
        editing: true,
      };
      this.material = item.material.id;
      this.handleChangeMaterial();
      this.color_product = item.color.id;
      this.handleChangeColor();
      this.sizes = item.sizes;
      this.product_order = { ...this.product_edit };
      console.log(item);
      this.index_product_edit = this.cart.items.findIndex(
        (product) =>
          item.reference === product.reference &&
          product.color.id === item.color.id &&
          product.material.id === item.material.id
      );
      item.editing = true;
      this.cart.items.splice(this.index_product_edit, 1, item);
      // this.cart.items[this.index_product_edit] = { ...item };
    },
    handleDeleteProduct(item) {
      if (this.isEditing()) {
        alert("Existe um produto em Edição!");
        return false;
      }
      this.item_delete = { ...item };
      this.dialogDeleteProduct = true;
    },
    verifyDisabledCompany() {
      if (this.companySessionSelected.id !== "") {
        return true;
      }
      return (
        this.cart.items.length > 0 ||
        this.product_order.reference !== "" ||
        this.isEditing()
      );
    },
    disabledOnEdit() {
      return this.isEditing();
    },
    onFocusSize(size, index) {
      if (parseInt(size.quantity) == 0) {
        this.sizes[index].quantity = "";
      }
    },
    onBlurSize(size, index) {
      if (size.quantity == "") {
        this.sizes[index].quantity = 0;
      }
    },
    handleReference() {
      this.message_add_to_cart = "";
    },
    providerIsSelected() {
      return Object.keys(this.provider).length > 0;
    },
    isEditing() {
      return Object.keys(this.product_edit).length > 0;
    },
    verifyProductsCart(product) {
      return (
        this.cart.items.find(
          (item) =>
            item.reference === product.reference &&
            product.color.color === item.color.color &&
            product.material.id === item.material.id
        ) !== undefined
      );
    },
    async searchProductAdvanced() {
      this.loadingDialogSearch = true;
      let params = { ...this.search };
      params.type = "advanced";
      params.company_promotion_id = this.company_promotion_id;
      params.franchise = this.company.id;
      console.log(params);
      let myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        let response = await fetch(`${URL}product/search-order`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(params),
        });
        let data = await response.json();
        this.products_search = data.products.map((item) => ({
          ...item,
          referenceFull: `${item.provider_code}${item.reference}`,
        }));
        this.dialogSearchAdvancedPanel = 1;
      } catch (error) {
        this.products_search = [];
        console.log(error);
      } finally {
        this.loadingDialogSearch = false;
      }
    },
    async handleClickSearchAdvanced() {
      this.message_add_to_cart = "";
      if (this.company.id == "") {
        this.error = "Selecione um Franqueado para poder Continuar";
        return false;
      }

      this.loadingDialogSearch = true;
      this.products_search = [];
      this.dialogSearchAdvancedPanel = 0;
      this.dialogSearchAvanced = true;
      this.radioGroupProduct = 0;
      this.loadingDialogSearch = false;

      this.getProviders();
      if (this.collections.length == 0) {
        this.getCollections(this.search.provider);
      }
      if (this.categories.length == 0) {
        this.getCategories(this.search.provider);
      }
      if (this.subcategories.length == 0) {
        this.getSubcategories(this.search.provider);
      }
      if (this.materials_search.length == 0) {
        this.getMaterialsSearch(this.search.provider);
      }
      if (this.colors_search.length == 0) {
        this.getColors(this.search.provider);
      }
      if (this.technologies.length == 0) {
        this.getTechnologies(this.search.provider);
      }
    },
    async handleConfirmAdvancedSearch() {
      if (this.radioGroupProduct == 0) {
        alert("Selecione um produto para poder continuar");
        return false;
      }

      console.log(this.radioGroupProduct);
      console.log(this.products_search);
      let productSelected = this.products_search.find(
        (item) =>
          `${item.id}${item.material_id}${item.color_id}` ===
          this.radioGroupProduct
      );
      this.product_order = { ...productSelected };
      if (!this.providerIsSelected()) {
        this.provider = {
          id: this.product_order.provider_id,
          name: this.product_order.provider_name,
          code: this.product_order.provider_code,
        };
      }
      await this.getMaterials(this.product_order.id);

      console.log(productSelected);
      console.log(this.attributes);

      if (productSelected.material_id !== "") {
        this.material = productSelected.material_id;
        this.handleChangeMaterial();
      }
      if (productSelected.product_has_attributes_id !== "") {
        this.color_product = productSelected.product_has_attributes_id;
        this.handleChangeColor();
      }
      this.dialogSearchAvanced = false;

      this.getGrids(this.product_order.grid_id);
      console.log(productSelected);
    },
    cancelOrder() {
      this.message_add_to_cart = "";
      this.material_error = "";
      this.error = "";
      this.dialogCancel = true;
    },
    handleConfirmCancelOrder() {
      this.loading = true;
      if (this.cart.id) {
        this.deleteOrderDraft(this.cart.id);
      }
      this.message_add_to_cart = "";
      this.products_search = [];
      this.product_edit = {};
      this.product_order = { ...this.product_new };
      this.color = { ...this.color_new };
      this.photo = "";
      this.reference = "";
      this.provider = {};
      this.company = {
        id: "",
        code: "",
        name: "",
        type: "",
        delivery_state: "",
      };
      this.price = "";
      this.companySelected = "";
      this.materials = [];
      this.attributes = [];
      this.material = "";
      this.colors = [];
      this.color_product = "";
      this.sizes = [];
      this.company_promotion_id = null;

      this.promotion = {
        id: null,
        description: "",
      };

      // LIMPA CARRINHO
      this.cart.items = [];
      this.cart.id = "";
      this.cart.provider_id = "";
      this.search.provider = "";
      this.cart.franchise_id = "";
      this.cart.status = "draft";
      this.cart.code = "";
      this.cart.company_promotion_id = null;

      this.material_error = false;
      this.error_validate = "";
      this.color_error = false;
      this.dialogCancel = false;
      this.$vuetify.goTo(0, {
        duration: 300,
        offset: 0,
        easing: "easeInOutCubic",
      });
      this.loading = false;
    },
    async handleConfirmDeleteProduct() {
      this.dialogDeleteProduct = false;
      console.log(this.item_delete);
      const data = {
        product_id: this.item_delete.id,
        material_id: this.item_delete.material.id,
        color_id: this.item_delete.color.color,
      };
      console.log(data);
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}order/${this.cart.id}/product-delete`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        let response = await res.json();
        if (response.status == "ok") {
          const index = this.cart.items.findIndex(
            (product) =>
              this.item_delete.reference === product.reference &&
              product.color.id === this.item_delete.color.id &&
              product.material.id === this.item_delete.material.id
          );
          this.cart.items.splice(index, 1);
          this.$vuetify.goTo(0, {
            duration: 300,
            offset: 0,
            easing: "easeInOutCubic",
          });
          this.message_add_to_cart = "Produto Removido com Sucesso";
        } else {
          alert(response.message);
        }
      } catch (error) {
        console.log(error);
        alert(
          "Não foi possível remover esse produto, entre em contato com o suporte 123"
        );
      }
      // const index = this.cart.items.findIndex(
      //   (product) =>
      //     this.item_delete.reference === product.reference &&
      //     product.color.id === this.item_delete.color.id &&
      //     product.material.id === this.item_delete.material.id
      // );
      // this.cart.items.splice(index, 1);
      // this.$vuetify.goTo(0, {
      //   duration: 300,
      //   offset: 0,
      //   easing: "easeInOutCubic",
      // });
      // if (this.cart.items.length === 0) {
      //   this.deleteOrderDraft(this.cart.id);
      //   this.provider = {};
      //   this.cart.id = "";
      //   this.cart.provider_id = "";
      //   this.search.provider = "";
      //   this.cart.franchise_id = "";
      //   this.cart.status = "draft";
      //   this.cart.code = "";
      // } else {
      //   this.message_add_to_cart = "Produto Removido com Sucesso";
      //   // this.saveOrderDraft();
      // }
    },
    handleCancelDeleteProduct() {
      this.item_delete = {};
      this.dialogDeleteProduct = false;
    },
    async getProviders() {
      if (this.providers.length == 0) {
        this.loadingProviders = true;
        try {
          let data = await CompanyAPI.getAll("?type=for");
          this.providers = data.sort((a, b) => (a.name > b.name ? 1 : -1));
        } catch (error) {
          this.providers = [];
          console.log(error);
        } finally {
          this.loadingProviders = false;
        }
      }
    },
    async getCollections(provider) {
      this.loadingCollections = true;
      this.collections = [];
      try {
        let response = await fetch(`
          ${URL}order/collection?provider=${provider}
        `);
        let data = await response.json();
        this.collections = data.sort((a, b) => (a.name > b.name ? 1 : -1));
        if (provider !== "") {
          this.searchWithProvider = true;
        } else {
          this.searchWithProvider = false;
        }
      } catch (error) {
        this.collections = [];
        console.log(error);
      } finally {
        this.loadingCollections = false;
      }
    },
    async getCategories(provider) {
      this.loadingCategories = true;
      this.categories = [];
      try {
        let response = await fetch(`${URL}order/category?provider=${provider}`);
        let data = await response.json();
        this.categories = data.sort((a, b) => (a.name > b.name ? 1 : -1));
        if (provider !== "") {
          this.searchWithProvider = true;
        }
      } catch (error) {
        this.categories = [];
        console.log(error);
      } finally {
        this.loadingCategories = false;
        // this.loading = false;
      }
    },
    async getSubcategories(provider) {
      this.loadingSubcategories = true;
      this.subcategories = [];
      try {
        let response = await fetch(
          `${URL}order/subcategory?provider=${provider}`
        );
        let data = await response.json();
        this.subcategories = data.sort((a, b) => (a.name > b.name ? 1 : -1));
        if (provider !== "") {
          this.searchWithProvider = true;
        }
      } catch (error) {
        this.subcategories = [];
        console.log(error);
      } finally {
        this.loadingSubcategories = false;
        // this.loading = false;
      }
    },
    async getMaterialsSearch(provider) {
      this.loadingMaterials = true;
      this.materials_search = [];
      try {
        let response = await fetch(`${URL}order/material?provider=${provider}`);
        let data = await response.json();
        this.materials_search = data.sort((a, b) => (a.name > b.name ? 1 : -1));
        if (provider !== "") {
          this.searchWithProvider = true;
        }
      } catch (error) {
        this.materials_search = [];
        console.log(error);
      } finally {
        this.loadingMaterials = false;
        // this.loading = false;
      }
    },
    async getColors(provider) {
      this.loadingColors = true;
      this.colors_search = [];
      try {
        let response = await fetch(`${URL}order/color?provider=${provider}`);
        let data = await response.json();
        this.colors_search = data.sort((a, b) => (a.name > b.name ? 1 : -1));
        if (provider !== "") {
          this.searchWithProvider = true;
        }
      } catch (error) {
        this.colors_search = [];
        console.log(error);
      } finally {
        this.loadingColors = false;
        // this.loading = false;
      }
    },
    async getTechnologies(provider) {
      this.loadingTechnologies = true;
      this.technologies = [];
      try {
        let response = await fetch(
          `${URL}order/technology?provider=${provider}`
        );
        let data = await response.json();
        this.technologies = data.sort((a, b) => (a.name > b.name ? 1 : -1));
        if (provider !== "") {
          this.searchWithProvider = true;
        }
      } catch (error) {
        this.technologies = [];
        console.log(error);
      } finally {
        this.loadingTechnologies = false;
        // this.loading = false;
      }
    },
    async saveOrderDraft(product = {}, edit) {
      if (this.cart.id == "") {
        await this.postSaveOrderDraft(this.cart, product, edit);
      } else {
        await this.saveProduct(this.cart.id, product, edit);
      }
    },
    async postSaveOrderDraft(data, product, edit) {
      if (this.cart.items.length === 0) {
        this.cart.provider_id = this.provider.id;
        this.cart.franchise_id = this.company.id;
        this.search.provider = this.cart.provider_id;
        this.cart.company_promotion_id = this.company_promotion_id;
        this.cart.items.push(product);
      }

      this.loading = true;
      const body = data;
      let myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        const response = await fetch(`${URL}order`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(body),
        });
        let data = await response.json();
        this.cart.id = data.order.id;
        this.cart.status = data.order.status;
        this.cart.code = data.order.code;
        console.log(data);
        console.log(this.cart);
        console.log(this.product);
        this.addToCart(product, edit);
      } catch (error) {
        console.log(error);
        this.error =
          "Atenção: Não foi possível salvar o pedido, tente novamente mais tarde";
      } finally {
        this.loading = false;
      }
    },
    // async putSaveOrderDraft(id, data) {
    //   this.loading = true;
    //   const body = data;
    //   let myHeaders = new Headers({
    //     "Content-Type": "application/json",
    //   });
    //   try {
    //     const response = await fetch(`${URL}order/${id}`, {
    //       method: "PUT",
    //       headers: myHeaders,
    //       body: JSON.stringify(body),
    //     });
    //     let data = await response.json();
    //     console.log(data);
    //   } catch (error) {
    //     console.log(error);
    //     this.error =
    //       "Atenção: Não foi possível atualizar o pedido, tente novamente mais tarde";
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    async saveProduct(order_id, product, edit) {
      try {
        const myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}order/${order_id}/product`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(product),
        });
        let response = await res.json();
        if (response.status == "ok") {
          if (!edit) {
            this.cart.items.push(product);
          }
          this.addToCart(product, edit);
          alert(response.message);
        } else {
          alert(response.message);
        }
      } catch (error) {
        alert("Problema ao salvar o produto, entre em contato com o suporte");
        console.log(error);
      }
    },
    async deleteOrderDraft(id) {
      if (id == "" || id == null) {
        return;
      }
      this.loading = true;
      try {
        const response = await fetch(`${URL}order/${id}`, {
          method: "DELETE",
        });
        let data = await response.json();
        console.log(data);
      } catch (error) {
        console.log(error);
        this.error =
          "Atenção: Não foi possível remover o pedido, tente novamente mais tarde";
      } finally {
        this.loading = false;
      }
    },
    async verifyDraftOrders() {
      this.loading = true;
      try {
        let url = `${URL}order/draft`;
        if (this.companySessionSelected.id !== "") {
          url = `${url}?franchise_id=${this.companySessionSelected.id}`;
        }
        const response = await fetch(url);
        let data = await response.json();
        console.log(data);
        if (data.length > 0) {
          this.drafts = data;
          this.dialogDraftOrders = true;
        }
      } catch (error) {
        console.log(error);
        this.error =
          "Atenção: Não foi possível carregar os pedidos em manutenção, tente novamente mais tarde";
      } finally {
        this.loading = false;
      }
    },
    async getDraft(id) {
      this.drafts = [];
      this.loading = true;
      try {
        const url = `${URL}order/draft/${id}`;
        const response = await fetch(url);
        let data = await response.json();
        this.retrieveCart(data);
      } catch (error) {
        console.log(error);
        this.error =
          "Atenção: Não foi possível carregar o pedido em manutenção, verifique sua conexão e tente novamente";
      } finally {
        this.loading = false;
      }
    },
    handleConfirmDraft() {
      if (this.radioGroupDraft == 0) {
        alert("Selecione um pedido para poder continuar");
        return false;
      }
      let draft = this.drafts.find((item) => item.id === this.radioGroupDraft);
      this.retrieveCart(draft);
      this.dialogDraftOrders = false;
    },
    handleChangeProviderAdvancedSearch() {
      console.log(this.search.provider);
      this.searchWithProvider = false;
      const provider = this.search.provider == null ? "" : this.search.provider;
      this.getCollections(provider);
      this.getCategories(provider);
      this.getSubcategories(provider);
      this.getMaterialsSearch(provider);
      this.getColors(provider);
      this.getTechnologies(provider);
    },
    retrieveCart(draft) {
      this.companySelected = draft.franchise_id;
      this.company = {
        id: draft.franchise.id,
        code: draft.franchise.code,
        name: draft.franchise.name,
        type: draft.franchise.type,
        delivery_state: draft.franchise.delivery_state,
      };
      this.provider = draft.provider;

      this.cart.id = draft.id;
      this.cart.provider_id = draft.provider.id;
      this.search.provider = draft.provider.id;
      this.cart.franchise_id = draft.franchise.id;
      this.cart.company_promotion_id = draft.company_promotion_id;
      this.cart.code = draft.code;
      this.cart.status = draft.status;
      this.cart.items = [];

      if (this.cart.company_promotion_id !== null) {
        this.getPromotion(this.cart.company_promotion_id);
      }

      let products = draft.products;

      for (let i = 0; i < products.length; i++) {
        const prod = products[i];
        let product = {
          id: prod.product.id,
          reference: prod.product.reference,
          name: prod.product.name,
          unit_id: prod.unit.id,
          unit_name: prod.unit.name,
          grid_id: prod.grid_id,
          category_id: prod.category.id,
          category_name: prod.category.name,
          subcategory_id: prod.subcategory.id,
          subcategory_name: prod.subcategory.name,
          price_cif: prod.product.price_cif,
          price_mult: prod.product.price_mult,
          provider_id: draft.provider.id,
          provider_name: draft.provider.name,
          provider_code: draft.provider.code,
          editing: false,
        };

        product.material = prod.material;
        product.color = {
          color: prod.attr.color_id,
          id: prod.attr.id,
          name: prod.color.name,
          photo: prod.attr.photo,
        };
        product.sizes = prod.sizes.map((size) => ({
          size: size.size,
          quantity: size.quantity,
        }));

        this.cart.items.push(product);
      }
    },
    async getPromotion(id) {
      this.loading = true;
      try {
        let response = await CompanyPromotionAPI.getById(id);
        this.promotion = response.promotion;
        this.company_promotion_id = this.promotion.id;
        this.provider = {
          id: this.promotion.provider.id,
          name: this.promotion.provider.name,
          code: this.promotion.provider.code,
        };
        this.search.provider = this.promotion.provider.id;
        this.cart.provider_id = this.promotion.provider.id;
      } catch (error) {
        this.company_promotion_id = null;
        this.error =
          "Não foi possível carregar os dados da promoção, entre em contato com o suporte";
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    handleClickGoToPromotion() {
      this.$router.push({
        name: "OrdersOnSale",
      });
    },
    getOptionsGrid() {
      let data = this.grid.closed_grid.split(";").map((item) => parseInt(item));
      data.unshift(0);
      console.log(this.sizes);
      console.log(data);
      return data;
    },
    async getShipping(id) {
      // this.loading = true;
      try {
        let response = await ShippingAPI.getById(id);
        if (Object.keys(response).length === 0) {
          let company = await CompanyAPI.getById(id);
          this.conditions = {
            minimum_order: {
              type:
                company.type_minimum_order == null
                  ? ""
                  : company.type_minimum_order,
              value: company.minimum_order,
            },
            shipping: {
              type: "",
              value: "",
            },
          };
        } else {
          this.conditions = {
            minimum_order: {
              value: response.company.minimum_order,
              type:
                response.company.type_minimum_order == null
                  ? ""
                  : response.company.type_minimum_order,
            },
            shipping: this.getShippingRules(response),
          };
        }
        console.log(JSON.stringify(this.conditions));
      } catch (error) {
        console.log(error);
      }
    },
    getShippingRules(response) {
      console.log(response);
      let rule = {
        value: "",
        type: response.type,
      };
      let notEmpty = (value) => value !== null && value !== "";
      let state = this.company.delivery_state;

      console.log(state);
      if (notEmpty(state)) {
        if (response.states.length > 0 && rule.value === "") {
          let res = response.states.find((item) => item.name === state);
          if (res) {
            rule.value = res.minimum_order;
          }
        }

        if (response.regions.length > 0 && rule.value === "") {
          let detailState = UF_REGIONS.find((item) => item.value === state);
          let res = response.regions.find(
            (item) => item.name === detailState.region
          );
          if (res) {
            rule.value = res.minimum_order;
          }
        }
      }

      if (rule.value === "") {
        rule.value = response.minimum_order;
      }
      return rule;
    },
    hitMinimumOrder() {
      if (this.conditions.minimum_order.type === "pair") {
        return (
          parseInt(this.conditions.minimum_order.value) <=
          this.getSumAmountOrder()
        );
      }
      console.log(parseFloat(this.conditions.minimum_order.value));
      console.log(parseFloat(this.getSumValueOrder()));
      return (
        parseFloat(this.conditions.minimum_order.value) <=
        parseFloat(this.getSumValueOrder())
      );
    },
    formatMinimumOrderValue() {
      if (this.conditions.minimum_order.type === "pair") {
        return `${parseInt(this.conditions.minimum_order.value)} Itens`;
      }
      return this.currencyEuaToBr(
        parseFloat(this.conditions.minimum_order.value)
      );
    },
    hitShippingCondition() {
      if (this.conditions.shipping.type === "pair") {
        return (
          parseInt(this.conditions.shipping.value) <= this.getSumAmountOrder()
        );
      }
      return (
        parseFloat(this.conditions.shipping.value) <=
        parseFloat(this.getSumValueOrder())
      );
    },
    formatShippingValue() {
      if (this.conditions.shipping.type === "pair") {
        return `${parseInt(this.conditions.shipping.value)} Itens`;
      }
      return this.currencyEuaToBr(parseFloat(this.conditions.shipping.value));
    },
  },
};
</script>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}
</style>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 13px;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}

.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}

.image-clickable {
  cursor: pointer;
}

.cart-editing {
  background-color: #ffab00;
}

.v-text-field--outlined.border-color-field >>> fieldset {
  border-color: #666;
}
</style>
